import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=39081b46&scoped=true"
import script from "./ModuleSettings.vue?vue&type=script&lang=js"
export * from "./ModuleSettings.vue?vue&type=script&lang=js"
import style0 from "./ModuleSettings.vue?vue&type=style&index=0&id=39081b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39081b46",
  null
  
)

export default component.exports